import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Pm2Grid } from 'RtUi/app/rtAdmin/Pm2/grids/Pm2Grid';
import { Pm2Router } from 'RtUi/app/rtAdmin/Pm2/Pm2.router';
import { InputFormControl } from 'RtUi/components/form/InputFormControl';
import { RtUiSearchForm } from 'RtUi/components/ui/RtUiForm';
import { TabbedLayout, TabbedLayoutTab } from 'RtUi/components/ui/TabbedLayout';
import { useTabs } from 'RtUi/components/ui/TabbedLayout/useTabs';

export const Pm2IndexContainer: FC = () => {
	const [tabs, activeTab, setActiveTab] = useTabs({
		Search: { header: 'Search' },
		Results: { header: 'Results', isDefault: true }
	});

	const navigate = useNavigate();

	const [hostname, setHostname] = useState<string>();
	const [username, setUsername] = useState<string>();
	const [processName, setProcessName] = useState<string>();
	const [processStatus, setProcessStatus] = useState<string>();

	const searchPm2 = async (event: React.FormEvent<HTMLFormElement>) => {
		try {
			event.preventDefault();
			setActiveTab('Results');
		} catch (e) {
			// TODO
		}
	};

	return (
		<TabbedLayout
			router={Pm2Router}
			activeTab={activeTab.header}
			onTabChange={setActiveTab}
		>
			<TabbedLayoutTab {...tabs.Search}>
				<RtUiSearchForm onSubmit={(e) => searchPm2(e)}>
					<InputFormControl
						label="Hostname"
						onChange={(hostname) => setHostname(hostname)}
						value={hostname}
					/>

					<InputFormControl
						label="Username"
						onChange={(username) => setUsername(username)}
						value={username}
					/>

					<InputFormControl
						label="Process Name"
						onChange={(processName) => setProcessName(processName)}
						value={processName}
					/>

					<InputFormControl
						label="Process Status"
						onChange={(processStatus) => setProcessStatus(processStatus)}
						value={processStatus}
					/>
				</RtUiSearchForm>
			</TabbedLayoutTab>
			<TabbedLayoutTab {...tabs.Results}>
				<>
					<Pm2Grid
						resourceParams={{
							processName: processName || undefined,
							hostname: hostname || undefined,
							username: username || undefined,
							status: processStatus || undefined
						}}
					/>
				</>
			</TabbedLayoutTab>
		</TabbedLayout>
	);
};

Pm2IndexContainer.displayName = 'Pm2IndexContainer';

Pm2Router.setIndexRtUiFunctionalComponent(Pm2IndexContainer);
